/** Espelha origem_ocorrencia (db_suprimentos) e OrigemOcorrenciaEnum (API.Suprimentos): quem produziu a ocorrência. */
export enum OrigemOcorrenciaEnum {
  Usuario = 1,
  Sistema = 2,
  Automacao = 3,
  RotinaAgendada = 4,
  ServicoExterno = 5,
}
